import { inject, Injectable } from '@angular/core';
import { Address, AddressService } from './address.service';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { StorageService } from './storage.service';

import { registerLocaleData } from '@angular/common';

import localePl from '@angular/common/locales/pl';
import localeEn from '@angular/common/locales/en';
import localeUk from '@angular/common/locales/uk';
import { Device } from '@capacitor/device';
import { MarketingConsentsService } from './marketing-consents.service';

const CURRRENT_LANGUAGE_KEY = 'CURRENT_LANGUAGE';

@Injectable({
    providedIn: 'root'
})
export class AppService {
    private _translateService = inject(TranslateService);
    private _storageService = inject(StorageService);
    private _data = inject(AddressService);
    private _marketingConsentsService = inject(MarketingConsentsService);
    
    private _router = inject(Router);

    public init() {
        return this._data
            .getCurrentAddress()
            .then((address: Address) => {
                if (address) {
                    this._router.navigate(['/dashboard']);
                } else {
                    this._router.navigate(['/intro']);
                }
            });
    }

    public initLanguage() {
        registerLocaleData(localePl);
        registerLocaleData(localeEn);
        registerLocaleData(localeUk);

        this._translateService.addLangs(['pl', 'en', 'uk']);
        
        return this._storageService
            .get(CURRRENT_LANGUAGE_KEY)
            .then(async (lang: string) => {
                if (!lang) {
                    lang = (await Device.getLanguageCode()).value;
                }

                this._translateService.setDefaultLang(lang);
                this._translateService.use(lang);
            });
    }

    public initMarketingConsents() {
        this._marketingConsentsService.getMarketingConsents();
    }

}
